import { isAndroid } from "../../utils/platformUtils"
import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: '100%',
        position: 'relative',
    },
    containerStoreItem: {
        width: width,
    },
    flatList: {
        width: '100%',
        flexGrow: 0,
    },
    map: {
        width: '100%',
        height: '100%',
    },
    cardContainer: {
        flex: 1,
        position: 'absolute',
        zIndex: 1,
        backgroundColor: 'transparent',
        width: Dimensions.get('window').width,
        bottom: 0,
        marginBottom: isAndroid() ? 15 : 30,
        pointerEvents: 'box-none',
    },
    card: {
        alignItems: 'flex-end',
        marginRight: 15,
        pointerEvents: 'box-none',
    },
    image: { width: 40, height: 40 },
    marginBottom: { marginBottom: 10 },
})

export default styles
